// graphqlReducers.js

import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT_REQUEST,
  SET_ACCESS_LEVEL,
  SET_PROFILE_NOT_FOUND,
  SET_DARK_MODE
} from "../actions/graphqlActions";
import { getInitialDarkMode } from "../../hooks/storage";

const initialState = {
  authenticated: false,
  email: null,
  accessLevel: null,   // <-- Important: we use this for routing!
  profileNotFound: false, // true once the profile lookup has definitively come back empty
  darkMode: getInitialDarkMode(), // seeded from localStorage/system preference; DB value reconciles once the profile fetch resolves
  error: null
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        ...state,
        authenticated: false,
        email: null,
        accessLevel: null,
        profileNotFound: false,
        error: null,
      };

    case USER_LOGIN_SUCCESS: {
      const nextEmail = action.payload?.email ?? state.email;
      return {
        ...state,
        authenticated: true,
        email: nextEmail,
        error: null,
      };
    }

    case SET_ACCESS_LEVEL:
      return {
        ...state,
        accessLevel: action.payload,
        profileNotFound: false,
      };

    case SET_PROFILE_NOT_FOUND:
      return {
        ...state,
        profileNotFound: true,
      };

    case SET_DARK_MODE:
      return {
        ...state,
        darkMode: action.payload,
      };

    case USER_LOGIN_FAIL:
      return {
        ...state,
        authenticated: false,
        email: null,
        accessLevel: null,
        profileNotFound: false,
        error: action.payload,
      };

    case USER_LOGOUT_REQUEST:
      return {
        ...initialState
      };

    default:
        // If this reducer doesn't recognize the action type, or doesn't
        // care about this specific action, return the existing state unchanged
      return state;
  }
}